import { Component } from '@angular/core';

@Component({
  selector: 'zdb-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent {
}
